import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faClock } from '@fortawesome/pro-solid-svg-icons';
import React from 'react';
import Select, { ControlProps, components, createFilter } from 'react-select';

import './styles.scss';

interface ListTimezonesProps {
    selectedValue?: ControlPropsOpt;
    onChange: (status: string) => void;
    options?: { value: string; label: string }[];
    isDisabled: boolean;
}

interface ControlPropsOpt {
    readonly value: string;
    readonly label: string;
}

const Control = ({ children, ...props }: ControlProps<ControlPropsOpt, false>) => {
    return (
        <components.Control {...props}>
            <span className="listTimezonesIcon">
                <FontAwesomeIcon icon={faClock} />
            </span>
            {children}
        </components.Control>
    );
};
const ListTimezones: React.FC<ListTimezonesProps> = ({ selectedValue, onChange, options = [], isDisabled = false }) => {
    const filterConfig = {
        ignoreCase: true,
        ignoreAccents: true,
        trim: true,
    };

    return (
        <Select
            placeholder="Select a timezone"
            className="listTimezones"
            classNamePrefix="timezone"
            menuPosition="absolute"
            value={options.find((val) => val.value === selectedValue?.value)}
            isSearchable
            name="timezones"
            options={options}
            onChange={(opt) => onChange(opt?.value || '')}
            filterOption={createFilter(filterConfig)}
            components={{ Control }}
            styles={{
                menuPortal: (base) => ({ ...base, zIndex: 9999 }),
            }}
            menuPortalTarget={document.body}
            isDisabled={isDisabled}
        />
    );
};
export default ListTimezones;
